import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import mediumZoom from 'medium-zoom'
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export const MarkdownRenderer = ({ markdown }: { markdown: string }) => {
  useEffect(() => {
    const zoom = mediumZoom('.react-markdown img', {
      background: localStorage.getItem("darkmode") === "false" ? "#fff" : "#000"
    })

    return () => {
      zoom.detach()
    }
  }, [markdown])

  return <div className="react-markdown">
    <ReactMarkdown
    remarkPlugins={[remarkGfm]}
    components={{
      table: ({ children }) => (
        <table className="table table-bordered w-auto">{children}</table>
      ),
      a: ({ href, children }) => {
        if (href && href.startsWith('/api/KnowledgeBase/ViewVideo/')) {
          return <video width="100%" src={href} controls preload="metadata" />;
        }
        if (href && (href.startsWith('/') || href.startsWith(window.location.origin))) {
          const newHref = href.replace(window.location.origin, '');
          return <Link to={newHref} className="markdown-link">{children}</Link>;
        }
        if (href && (href.startsWith('https://www.youtube.com/watch?v=') || href.startsWith('https://youtu.be/'))) {
          const newHref = "https://www.youtube.com/embed/" + href.replace("https://www.youtube.com/watch?v=", "").replace("https://youtu.be/", "");
          return <iframe className="border-0" width="100%" height="480" src={newHref} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />;
        }
        return <a target="_blank" rel="noopener noreferrer" href={href} className="markdown-link">{children}</a>;
      },
      img: ({ src, alt }) => (
        <img src={src} alt={alt} className="markdown-image" />
      ),
    }}
  >
    {markdown}
  </ReactMarkdown>
  </div>;
};